import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import Login from "./Login";
import DevOpsWorkItems from "./DevOpsWorkItems";
import AssessmentIntake from "./AssessmentIntake";
import AssessmentPage from "./AssessmentPage";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";

const msalInstance = new PublicClientApplication(msalConfig);

export default function AppWithAuthProvider() {
  return (
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/workitems" element={<DevOpsWorkItems />} />
          <Route path="/intake" element={<AssessmentIntake />} />
          <Route path="/assessment" element={<AssessmentPage />} />
          <Route path="/*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </MsalProvider>
  );
}
